<template>
  <div class="page lightmap">
    <navigation-header />
    <div class="main">
      <h2 class="heading-medium">
        {{ $t('privacy_policy.heading') }}
      </h2>
      <heading-chip />
      <div class="subtext-content">
        Updated: {{ $d(new Date(PRIVACY_DATE), 'short') }}
      </div>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="policy-content" v-html="privacyHtml" />
    </div>
    <div class="subtext-content">
      {{ PRIVACY_VERSION }}
    </div>
    <accounts-footer />
  </div>
</template>

<script setup>
import NavigationHeader from '../components/NavigationHeader.vue';
import TextSection from '../components/TextSection.vue';
import HeadingChip from '../components/HeadingChip.vue';
import AccountsFooter from '../components/AccountsFooter.vue';
import { ref, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();

// NOTE: reference values need to be manually updated when any of the source documents are modified: privacy.*.html
const PRIVACY_DATE = '2026-04-20T00:00:00';     // modification date (time suffix forces local timezone parsing)
const PRIVACY_VERSION = '4158-9528-6109 v.2';   // source document version, for legal reference only

const privacyHtml = ref('');

const htmlModules = import.meta.glob('../../locales/privacy.*.html', { query: '?raw', import: 'default' });

watchEffect(async () => {
    const localeFile = `../../locales/privacy.${locale.value}.html`;
    const fallbackFile = `../../locales/privacy.en.html`;
    const load = htmlModules[localeFile] ?? htmlModules[fallbackFile];
    if (load) {
        privacyHtml.value = await load();
    }
});
</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;
@use '../styles/Accounts' as Accounts;

.page {
  @include Accounts.Default;
  @include Accounts.Container;
}
</style>